import { useState, useEffect } from 'react'

import useCart from 'store/CartProvider'

export const useQuantityControls = product => {
  const [quantity, setQuantity] = useState(product.quantity)

  const { changeQuantity, deleteProduct } = useCart()

  useEffect(() => {
    setQuantity(product.quantity)
  }, [product.quantity])

  const handleIncrease = e => {
    if (e) e.preventDefault()
    const newQuantity = quantity + 1
    setQuantity(newQuantity)
    changeQuantity(product.sku, newQuantity)
  }

  const handleDecrease = e => {
    if (e) e.preventDefault()
    if (quantity <= 1) {
      return
    } else {
      const newQuantity = quantity - 1
      setQuantity(newQuantity)
      changeQuantity(product.sku, newQuantity)
    }
  }

  const handleDelete = e => {
    if (e) e.preventDefault()
    return deleteProduct(product.sku)
  }

  return { quantity, handleIncrease, handleDecrease, handleDelete }
}
